import React, { useMemo, useState } from 'react';
import { Field, Text, Area, File, Check, useEmit } from './fields';

/**
 * Emits: { durationFrom, durationTo, durationTime, methodStatementFile,
 *          riskAssessmentFile, drawingsFile, additionalInfo }
 * File fields carry the filename only (uploads deferred).
 */
const DescriptionOfWork = ({ onDataChange }) => {
    const [durationFrom, setDurationFrom] = useState('');
    const [durationTo, setDurationTo] = useState('');
    const [durationTime, setDurationTime] = useState('');
    const [methodStatementFile, setMethodStatementFile] = useState('');
    const [methodStatementNA, setMethodStatementNA] = useState(false);
    const [riskAssessmentFile, setRiskAssessmentFile] = useState('');
    const [riskAssessmentNA, setRiskAssessmentNA] = useState(false);
    const [drawingsFile, setDrawingsFile] = useState('');
    const [additionalInfo, setAdditionalInfo] = useState('');

    const data = useMemo(() => ({
        durationFrom, durationTo, durationTime,
        methodStatementFile: methodStatementNA ? '' : methodStatementFile,
        riskAssessmentFile: riskAssessmentNA ? '' : riskAssessmentFile,
        drawingsFile, additionalInfo,
    }), [durationFrom, durationTo, durationTime, methodStatementFile, methodStatementNA, riskAssessmentFile, riskAssessmentNA, drawingsFile, additionalInfo]);
    useEmit(data, onDataChange);

    return (
        <div className="v3-wp-card">
            <div className="v3-wp-card-head"><h6 className="v3-wp-card-title">Description of Work</h6></div>
            <div className="v3-wp-grid cols-3">
                <Field label="Duration From"><Text type="date" value={durationFrom} onChange={setDurationFrom} /></Field>
                <Field label="Duration To"><Text type="date" value={durationTo} onChange={setDurationTo} /></Field>
                <Field label="Time"><Text type="time" value={durationTime} onChange={setDurationTime} /></Field>
            </div>
            <hr className="v3-wp-divider" />
            <div className="v3-wp-grid">
                <Field label="Method of Statement">
                    <File accept="application/pdf" onChange={(f) => setMethodStatementFile(f ? f.name : '')} />
                    <Check id="ms-na" label="N/A" checked={methodStatementNA} onChange={setMethodStatementNA} />
                </Field>
                <Field label="Risk Assessment">
                    <File accept="application/pdf" onChange={(f) => setRiskAssessmentFile(f ? f.name : '')} />
                    <Check id="ra-na" label="N/A" checked={riskAssessmentNA} onChange={setRiskAssessmentNA} />
                </Field>
                <Field label="Drawings / Layouts / Plans" full>
                    <File onChange={(f) => setDrawingsFile(f ? f.name : '')} />
                </Field>
                <Field label="Additional Information" full><Area value={additionalInfo} onChange={setAdditionalInfo} rows={3} /></Field>
            </div>
        </div>
    );
};

export default DescriptionOfWork;
